import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Table,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Formik } from "formik";
import { jwtDecode } from "jwt-decode";
import AsyncSelect from "react-select/async";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import "react-phone-input-2/lib/style.css";
import { IoEyeOutline } from "react-icons/io5";
import FadeLoaderComponent from "../../../components/loader-component";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { roleTypes } from "../../../data/roleType";
import DatePickerField from "../../../components/input/date-picker-field";

const ProductRequestView = () => {
  const alertRef = useRef(null);
  const [selectedData, setSelectedData] = useState();
  const { id } = useParams();
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const [decodedToken, setDecodedToken] = useState();
  const token = localStorage.getItem("coyote-token");
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getProductRequest = async () => {
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}product-request/${id}/detail`,
        config
      );
      const productRequests = response.data.response.data;
      handleShowView(productRequests);
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "information");
      setLoader(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getProductRequest();
      } catch (err) { }
    };
    fetchData();
  }, [decodedToken]);

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (
      response.data.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const handleShowView = async (item) => {
    if (item) {
      setSelectedData({
        id: item.id || null,
        shipTo: item.shipTo || null,
        userName: item.userName || null,
        warehouseName: item.warehouseName || null,
        status: item?.status,
        notes: item?.notes,
        date: item.date || "",

        productRequests: item.products,
      });
      setLoader(false);
    }
  };

  const [itemView, setItemView] = useState();

  const [itemViewModel, setItemViewModel] = useState(false);
  const handleView = async (e, item) => {
    e.preventDefault();
    setItemView(item);
    setItemViewModel(true);
  };

  const handleCloseView = async () => {
    setItemViewModel(false);
  };
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    function toggleStickyNames() {
      const isWideScreen = window.innerWidth > 650;

      const stickyHeadName = document.querySelector(".sticky-head-name");
      const stickyDataNames = document.querySelectorAll(".sticky-data-names");

      if (isWideScreen) {
        stickyHeadName?.classList.add("sticky-action-head-buttons");
        stickyDataNames.forEach((data) =>
          data.classList.add("sticky-action-buttons"),
        );
      } else {
        stickyHeadName?.classList.remove("sticky-action-head-buttons");
        stickyDataNames.forEach((data) =>
          data.classList.remove("sticky-action-buttons"),
        );
      }
    }
    toggleStickyNames();
    window.addEventListener("resize", toggleStickyNames);
    return () => window.removeEventListener("resize", toggleStickyNames);
  });

  return (
    <>
      <div>
        <style>
          {`
          .table-user .sticky-action-buttons {
            background-color: #ffffff !important;
            border: none;
            z-index: 2;
            height: auto;
          }
          .table-user .tr-user:hover .sticky-action-buttons {
            background-color: #f5f6fa !important;
          }
          .table-user .sticky-action-head-buttons {
            background: #e2e4e9 !important;
          }
          .table-user .sticky-action-head-buttons,
          .table-user .sticky-action-buttons {
            left: 0;
            z-index: 1;
            width: 180px;
            position: absolute;
            height: inherit;
            display: flex;
            align-items: center;
            padding-left: 15px;
          }
          .table-user .th-user:nth-child(2),
          .table .td-user:nth-child(2) {
            padding-left: 190px !important;
          }
           @media (max-width: 650px) {
            .table-user .sticky-action-head-buttons,
            .table-user .sticky-action-buttons {
               position: static !important;
               width: auto !important;
            }
            .table-user .th-user:nth-child(2),
            .table .td-user:nth-child(2) {
              padding-left: 0.75rem !important;
            }
          }
        `}
        </style>
        <div className="bd-example">
          <div className="d-flex justify-content-between flex-wrap pl-0">
            <Modal
              show={itemViewModel}
              onHide={handleCloseView}
              backdrop="true"
              keyboard={true}
              size="lg"
            >
              <Modal.Header className="custom-modal-header">
                <Modal.Title>View Item</Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  onClick={handleCloseView}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>
              <Formik initialValues={itemView} enableReinitialize>
                {({ values }) => (
                  <>
                    <Form className="form-horizontal ps-3 pe-3">
                      <FocusError />
                      <Modal.Body>
                        <Row>
                          <Col sm="6">
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="ProductId"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Description
                              </Form.Label>
                              <div title={values.description || ""}>
                                <AsyncSelect
                                  name="productId"
                                  cacheOptions={false}
                                  style={{ fontSize: "0.8rem" }}
                                  isDisabled={true}
                                  defaultOptions={false}
                                  value={
                                    values?.productId
                                      ? {
                                        value: values?.productId,
                                        label:
                                          values?.productName ||
                                          "Selected Product",
                                      }
                                      : null
                                  }
                                  placeholder="Search Product"
                                  isClearable
                                  noOptionsMessage={(inputValue) =>
                                    inputValue.inputValue
                                      ? "No options found"
                                      : null
                                  }
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "white",
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: state.isSelected
                                        ? "#007bff"
                                        : state.isFocused
                                          ? "#e6f7ff"
                                          : "#fff",
                                      color: "#333",
                                      fontSize: "0.8rem",
                                    }),
                                    menuPortal: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col sm="6">
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="manufacturerId"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Make
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                                title={values.manufacturerName || ""}
                              >
                                <Form.Control
                                  readOnly
                                  type="text"
                                  id={`manufacturerName`}
                                  name={`manufacturerName`}
                                  disabled={true}
                                  value={values.manufacturerName || ""}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto", // Disable interaction when not enabled
                                    width: "100%",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="model"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Model
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                                title={values.model || ""}
                              >
                                <Form.Control
                                  readOnly
                                  type="text"
                                  id={`model`}
                                  name={`model`}
                                  disabled={true}
                                  value={values.model || ""}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto", // Disable interaction when not enabled
                                    width: "100%",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col sm="6">
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="siteName"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Site Name
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                                title={values.siteName || ""}
                              >
                                <Form.Control
                                  readOnly
                                  type="text"
                                  id={`siteName`}
                                  name={`siteName`}
                                  disabled={true}
                                  value={values.siteName || ""}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="description"
                                column
                                sm="12"
                                className="control-label align-self-center mb-0"
                              >
                                Description
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative", // Ensure proper positioning
                                }}
                              >
                                <Form.Control
                                  readOnly
                                  type="textarea"
                                  id={`description`}
                                  as="textarea"
                                  // style={{ }}
                                  disabled={true}
                                  name={`description`}
                                  value={values.description}
                                  style={{
                                    resize: "none",
                                    width: "100%",
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="quantity"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0 ps-"
                              >
                                Quantity
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative", // Ensure proper positioning
                                }}
                              >
                                <Form.Control
                                  type="number"
                                  name={`quantity`}
                                  step="1"
                                  value={values.quantity}
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto", // Disable interaction when not enabled
                                    width: "100%",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>

                          <Col sm={6}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="rate"
                                column
                                sm="6"
                                className="control-label align-self-center mb-0"
                              >
                                Rate
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative", // Ensure proper positioning
                                }}
                              >
                                <Form.Control
                                  type="number"
                                  step="0.01"
                                  name={`rate`}
                                  value={values.rate || ""}
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={6}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="amount"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Amount
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative", // Ensure proper positioning
                                }}
                              >
                                <Form.Control
                                  type="number"
                                  step="0.01"
                                  pattern="^\d+(\.\d{0,2})?$"
                                  name={`amount`}
                                  value={values.quantity * values.rate}
                                  readOnly
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>

                          <Col sm={6}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="jobId"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Job
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative", // Ensure proper positioning
                                }}
                              >
                                <Form.Control
                                  type="text"
                                  name={`jobId`}
                                  value={values.jobName || 'No Job Assigned'}
                                  readOnly
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={6}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="systemId"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                System
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <Form.Control
                                  type="text"
                                  name={`systemId`}
                                  value={values.systemName || 'N/A'}
                                  readOnly
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>

                          <Col sm={6}>
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="phaseId"
                                column
                                sm="4"
                                className="control-label align-self-center mb-0"
                              >
                                Phase
                              </Form.Label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <Form.Control
                                  type="text"
                                  name={`phaseId`}
                                  value={values.phaseName || 'N/A'}
                                  readOnly
                                  disabled={true}
                                  style={{
                                    fontSize: "0.8rem",
                                    pointerEvents: "auto",
                                    backgroundColor: "#fff",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Modal.Body>
                    </Form>
                  </>
                )}
              </Formik>
            </Modal>
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header className="custom-modal-header">
                <Modal.Title className="h6">Notes</Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Control
                      type="text"
                      disabled={true}
                      style={{ backgroundColor: "#fff", color: "#8A92A6" }}
                      value={
                        selectedData?.status
                          ? selectedData.status.charAt(0).toUpperCase() +
                          selectedData.status.slice(1).toLowerCase()
                          : ""
                      }
                      rows={4}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      value={selectedData?.notes}
                      disabled={true}
                      style={{ backgroundColor: "#fff", color: "#8A92A6" }}
                      rows={4}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
            </Modal>
          </div>
        </div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            ...selectedData,
          }}
        >
          {() => (
            <Form>
              <FocusError />
              <Row>
                <Col xl="12" lg="12" ref={alertRef}>
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={() =>
                            navigate("/dashboard/app/product-request-list")
                          }
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Product Request</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">Details</h4>
                      </div>
                      <div>
                        {isCollapsed && selectedData ? (
                          <>
                            <div
                              onClick={toggleCollapse}
                              className="sidebar-toggle"
                              style={{
                                position: "initial",
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="icon"
                                style={{ transform: "rotate(270deg)" }}
                              >
                                <svg
                                  width="20"
                                  className="icon-20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.25 12.2744L19.25 12.2744"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                              </i>
                            </div>
                          </>
                        ) : (
                          selectedData && (
                            <>
                              <div
                                className="sidebar-toggle"
                                onClick={toggleCollapse}
                                style={{
                                  position: "initial",
                                  marginRight: "1.5rem",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  className="icon"
                                  style={{ transform: "rotate(90deg)" }}
                                >
                                  <svg
                                    width="20"
                                    className="icon-20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.25 12.2744L19.25 12.2744"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </i>
                              </div>
                            </>
                          )
                        )}
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <AlertNotificationSimple
                        type={alert.type}
                        message={alert.message}
                        show={alert.show}
                        onClose={() => setAlert({ ...alert, show: false })}
                      />
                      {!isCollapsed && selectedData && !loader && (
                        <Form className="form-horizontal p-3">
                          <Row className="mb-4 flex align-items-end new-product-request-info">
                            <Col md={4}>
                              <DatePickerField
                                className="col-md-12 form-group"
                                name="date"
                                placeholder="MM/DD/YYYY"
                                value={selectedData.date}
                                onChange={() => { }}
                                disabled={true}
                                label="Date"
                              />
                            </Col>
                            <Col md={4}>
                              <Form.Group className="col-md-12 form-group relative">
                                <Form.Label htmlFor="status">Status</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    id="status"
                                    type="text"
                                    name="status"
                                    placeholder="Status"
                                    value={
                                      selectedData?.status
                                        ? selectedData.status
                                          .charAt(0)
                                          .toUpperCase() +
                                        selectedData.status
                                          .slice(1)
                                          .toLowerCase()
                                        : ""
                                    }
                                    disabled={true}
                                    style={{
                                      backgroundColor: "#fff",
                                      color: "#8A92A6",
                                    }}
                                  />
                                  {selectedData?.notes !== "" &&
                                    selectedData?.notes !== null && (
                                      <div className="d-flex align-items-center">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip>{"View Notes"}</Tooltip>
                                          }
                                        >
                                          <InputGroup.Text
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowModal(true)}
                                          >
                                            <TextSnippetIcon
                                              style={{ color: "#3a57e8" }}
                                            />
                                          </InputGroup.Text>
                                        </OverlayTrigger>
                                      </div>
                                    )}
                                </InputGroup>
                              </Form.Group>
                            </Col>

                            <Col
                              md={4}
                              className="flex justify-content-end"
                              style={{
                                display: "flex",
                                justifyContent: "end",
                              }}
                            >
                              <Form.Group className="col-md-12 form-group flex flex-end">
                                <Form.Label className="d-flex w-100 flex-nowrap">
                                  <span
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Requesting Warehouse
                                  </span>
                                  <span
                                    className="text-danger d-flex flex-row"
                                    style={{ width: "100%" }}
                                  >
                                    <Form.Control
                                      title={selectedData?.warehouseName}
                                      readOnly
                                      type="text"
                                      style={{
                                        marginLeft: "2rem",
                                        width: "100%",
                                      }}
                                      value={selectedData?.warehouseName || ""}
                                    />
                                  </span>
                                </Form.Label>

                                <Form.Control
                                  id="shipTo"
                                  as="textarea"
                                  type="text"
                                  name="shipTo"
                                  placeholder="Enter Shipment Address"
                                  value={selectedData?.shipTo}
                                  style={{
                                    resize: "none",
                                    height: "150px",
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Form>
                      )}
                      {selectedData && !loader && (
                        <Formik
                          initialValues={{
                            items: selectedData?.productRequests || [],
                            id: selectedData?.id,
                          }}
                          enableReinitialize
                        >
                          {({ values }) => (
                            <>
                              <Form>
                                <FocusError />

                                <div style={{ overflowX: "auto", width: "100%" }}>
                                  <Table
                                    id="product-request-list-table datatable"
                                    className="table-user"
                                    role="grid"
                                    responsive
                                    data-toggle="data-table"
                                    style={{ width: "100%", minWidth: "1500px" }}
                                  >
                                    <thead>
                                      <tr
                                        style={{ backgroundColor: "#e2e4e9" }}
                                        className="tr-user"
                                      >
                                     
                                        <th className="sticky-head-name th-user" style={{ minWidth: "100px" }}>
                                          Quantity
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Make
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Model
                                        </th>  
                                           <th className=" th-user" style={{ minWidth: "200px" }}>
                                          Description
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          SKU
                                        </th>
                                       
                                    
                        
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Rate
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Amount
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Job
                                        </th>
                        
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          System
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Phase
                                        </th>
                            <th className="th-user" style={{ minWidth: "200px" }}>
                                          Order Status
                                        </th>
                                        <th className="th-user" style={{ minWidth: "200px" }}>
                                          Site Name
                                        </th>
                                        <th className="th-user" style={{ minWidth: "100px" }}>
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    {values.items && values.items.length > 0 ? (
                                      <tbody>
                                        {values.items.map((item, index) => (
                                          <tr key={index} className="tr-user">
                                           
                                            <td className="sticky-data-names  td-user">
                                              <Form.Control
                                                readOnly
                                                type="number"
                                                value={item.quantity}
                                                className="ms-3"
                                              />
                                            </td>
                                            <td className="td-user">
                                              <Form.Control
                                                readOnly
                                                title={item.manufacturerName}
                                                type="text"
                                                style={{ width: "200px" }}
                                                value={
                                                  item.manufacturerName || ""
                                                }
                                              />
                                            </td>
                                            <td className="td-user">
                                              <Form.Control
                                                readOnly
                                                title={item.model}
                                                type="text"
                                                style={{ width: "200px" }}
                                                value={item.model || ""}
                                              />
                                            </td> 
                                             <td className="td-user">
                                              <Form.Control
                                                title={item.description || ""}
                                                readOnly
                                                type="text"
                                                style={{ width: "200px" }}
                                                value={item.description || ""}
                                              />
                                            </td>                
                                            <td className="td-user">
                                              <Form.Control
                                                title={item.sku}
                                                readOnly
                                                type="text"
                                                style={{ width: "200px" }}
                                                value={item.sku || ""}
                                              />
                                            </td>
                                           
                                            <td className="td-user">
                                              <Form.Control
                                                readOnly
                                                type="number"
                                                style={{ width: "200px" }}
                                                value={item.rate || ""}
                                              />
                                            </td>
                                            <td className="td-user">
                                              <Form.Control
                                                readOnly
                                                type="number"
                                                style={{ width: "200px" }}
                                                value={
                                                  item.rate * item.quantity || 0
                                                }
                                              />
                                            </td>
                                            <td className="td-user">
                                              <div title={item?.jobName}>
                                                <Form.Control
                                                  readOnly
                                                  type="text"
                                                  style={{ width: "200px" }}
                                                  value={item.jobName  || 'No Job Assigned'}
                                                />
                                              </div>
                                            </td>
                                            <td className="td-user">
                                              <div title={item?.systemName}>
                                                <Form.Control
                                                  readOnly
                                                  type="text"
                                                  style={{ width: "200px" }}
                                                  value={item.systemName || 'N/A'}
                                                />
                                              </div>
                                            </td>
                                            <td className="td-user">
                                              <div title={item?.phaseName}>
                                                <Form.Control
                                                  readOnly
                                                  type="text"
                                                  style={{ width: "200px" }}
                                                  value={item.phaseName || 'N/A'}
                                                />
                                              </div>
                                            </td>
                         <td className="td-user">
                                              <Form.Control
                                                readOnly
                                                title={item.orderStatus}
                                                type="text"
                                                style={{ width: "200px" }}
                                                value={item.orderStatus || ""}
                                              />
                                            </td>
                                            <td className="td-user">
                                              <div title={item?.siteName}>
                                                <Form.Control
                                                  readOnly
                                                  type="text"
                                                  style={{ width: "200px" }}
                                                  value={item.siteName  || 'N/A'}
                                                />
                                              </div>
                                            </td>
                        
                                            <td style={{ textWrap: "unset" }} className="td-user">
                                              <div className="d-flex gap-2">
                                                <Link
                                                  className={`btn btn-sm btn-icon btn-success`}
                                                  data-toggle="tooltip"
                                                  data-placement="top"
                                                  onClick={(e) => {
                                                    e.preventDefault();

                                                    handleView(
                                                      e,
                                                      values.items[index]
                                                    );
                                                  }}
                                                  title="View"
                                                  data-original-title="View"
                                                >
                                                  <span className="btn-inner">
                                                    <IoEyeOutline
                                                      style={{
                                                        width: "20px",
                                                        height: "20px",
                                                      }}
                                                    />
                                                  </span>
                                                </Link>{" "}
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    ) : (
                                      <tbody>
                                        <tr>
                                          <td colSpan={8}>
                                            <div className="d-flex w-100 justify-content-center">
                                              <p>
                                                No product request item found
                                              </p>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    )}
                                  </Table>
                                </div>
                              </Form>
                            </>
                          )}
                        </Formik>
                      )}

                      {loader && <FadeLoaderComponent />}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ProductRequestView;
